
import { parentValidator } from '~/fc/advancedOptionHelper'
import { MERGE_OPTION_IDS } from '~/config/config'
import FieldChild from './FieldChild'
const mergeOptionId = MERGE_OPTION_IDS

export default {
    name: 'FieldParent',
    components: { FieldChild },
    props: ['field', 'uid', 'slug', 'inPage'],
    computed: {
        selection() {
            return this.$store.state.advancedSetting.userData.allSelection &&
                this.$store.state.advancedSetting.userData.allSelection[this.uid]
                ? this.$store.state.advancedSetting.userData.allSelection[this.uid]
                : {}
        },
        list() { return this.$store.state.list },
        isMergeCheckbox() { return mergeOptionId.includes(this.field.id) },
        show() { return !this.isMergeCheckbox || (this.list?.length > 1) },
        info() { return this.$store.state.info },
        enablePreview() { return this.info.customVariables?.enablePreview || false },
        validField() {
            if (this.field.only_multifile) return this.inPage && this.enablePreview
            return parentValidator(this.field, this.selection)
        }
    }
}
